<div class="p-32">
  <div class="flex justify-between">
    <div class="flex">
      <div class="flex flex-col">
        <div class="flex flex-row mb-8 search">
          <div class="mat-subtitle-2 fw-600 fs-20 mt-4">{{'INSTANCE_SUMMARY.SELECT_DATABASE' | transloco}}</div>
          <app-search-filter *ngIf="backupResults?.length !== 0" class="ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
        </div>
        <div class="subtitle">{{'INSTANCE_SUMMARY.SERVER' | transloco}}:<span class="ml-4">{{server | titlecase}}</span></div>
      </div>
    </div>
    <mat-icon svgIcon="close" class="icon-md-2 cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
  </div>
  <mat-divider class="neutral-2 mb-16 mt-8"></mat-divider>
  <app-table [initialDataSource]="backupResults" [searchTerm]="searchTerm" [displayColumns]="displayColumns" [dataLoading]="false" [dataSourceLength]="true" (approve)="selectDatabase($event)" pageName="selectDatabase" [selectedTenant]="selectedTenant" ></app-table>
  <mat-divider class="neutral-2 mb-16 mt-24"></mat-divider>
  <div class="flex flex-row justify-end mt-32">
    <button (click)="cancel()" class="flex justify-items-center items-center cancel-btn mr-16 pr-16 pl-16 pt-8 pb-8">
      {{ 'BUTTONS.CANCEL' | transloco }}
    </button>
    <button [ngClass]="{'disabled': !selectedDatabase}" class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" type="button"
      (click)="selectClick()">{{ 'BUTTONS.SELECT' | transloco }}
    </button>
  </div>
</div>

